import CompanyCreate from './CompanyCreate.vue'
export {CompanyCreate}
export default CompanyCreate

